import { render, staticRenderFns } from "./joinRules.vue?vue&type=template&id=2779dc32&scoped=true"
import script from "./joinRules.vue?vue&type=script&lang=js"
export * from "./joinRules.vue?vue&type=script&lang=js"
import style0 from "./joinRules.vue?vue&type=style&index=0&id=2779dc32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779dc32",
  null
  
)

export default component.exports